import { createAsyncThunk } from '@reduxjs/toolkit';
import { ReportsMetaDataResponse } from 'src/types/reportingTypes';

export const fetchReportsMetaData = createAsyncThunk<
	ReportsMetaDataResponse,
	FetchReportMetaDataPayload,
	{ rejectValue: string }
>(
	'reporting/fetchReportsMetaData',
	async ({ api, id }, { rejectWithValue }) => {
		try {
			return await api.getUnifiedReportingMetaData(id);
		} catch (error) {
			const message =
				error instanceof Error
					? error.message
					: 'An unexpected error occurred';
			return rejectWithValue(message);
		}
	},
);

type FetchReportMetaDataPayload = {
	api: {
		getUnifiedReportingMetaData: (
			id: string,
		) => Promise<ReportsMetaDataResponse>;
	};
	id: string;
};
